'use client';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIosRounded';
import { IconButton, Typography } from '@mui/material';
import Link from 'next/link';
import { useParams } from 'next/navigation';

const TITLE = 'My Rewards';

const RewardHeader: React.FC = () => {
  const params = useParams();

  return (
    <div className='animate-in slide-in-from-right ease-in-out'>
      <div className='flex items-center py-4'>
        <IconButton size='small' component={Link} href={`/${params.subdomain}/reward`} className='!absolute left-2'>
          <ArrowBackIosIcon fontSize='small' />
        </IconButton>
        <Typography variant='h6' textAlign='center' className='w-full'>
          {TITLE}
        </Typography>
      </div>
    </div>
  );
};

export default RewardHeader;
